<template>
  <section
    class="page-container"
  >
    <div class="mg-b-30">
      <v-radio-group
        v-model="filter.merchant_platform"
        button
        :list="serverTypeOption"
        @change="filterData"></v-radio-group>
    </div>
    <div class="filter-top">
      <v-input
        v-model="filter.search"
        :prefixIcon="'el-icon-search'"
        placeholder="Policy, Policyholder Name/ HKID/ Passport, Accident Name/ HKID/ Passport"
        @keyEnter="filterData" />
    </div>
    <div
      class="filter-container  flex border-bottom-radius">
      <div class="filter-left">
        <div class="form-item">
          <span>Accident Date</span>
          <div class="flex">
            <v-date-picker
              v-model="filter.accident_date"
              :clearable="true"
              type="daterange"
              @change="filterData" />
          </div>
        </div>
        <div
          class="form-item">
          <span>Assignee</span>
          <span>
            <v-select
              v-model="filter.assignee_id"
              icon="user-nurse"
              :clearable="true"
              :list="globalOptions.assignee"
              @change="filterData" />
          </span>
        </div>
        <div
          class="filter-box status-button">
          <div class="filter-box-text">
            <span>Status</span>
          </div>
          <div class="flex">
            <v-checkbox-group
              v-model="filter.status"
              :borderBlock="true"
              :list="statusTypeOptions"
              @change="filterData" />
          </div>
        </div>
      </div>
      <div class="filter-middler">
        <div class="form-item">
          <span>
            Product Type
            <span
              class="all"
              @click="handlerSelectAll('class_id')">All</span>
            <span
              class="all"
              @click="handlerNoneAll('class_id')">None</span>
          </span>
          <div class="flex-sb">
            <div class="half">
              <span>Auto-Quote</span>
              <v-checkbox
                v-model="motor_select"
                class="mg-t-8 mg-b-10"
                :is-indeterminate="isAllMotorSelect"
                @change="handleSelectQuote"><span class="fs-14 color-dark fw-600">Motors</span></v-checkbox>
              <v-checkbox-group
                v-model="class_id"
                :list="motorClassOptions"
                :isColumn="false"
                @change="filterData"></v-checkbox-group>
              <v-checkbox
                v-model="none_motor_select"
                class="mg-t-8 mg-b-10"
                :is-indeterminate="isNoneMotorSelect"
                @change="handleSelectNoneQuote"><span class="fs-14 color-dark fw-600">Non-Motors</span></v-checkbox>
              <v-checkbox-group
                v-model="class_id"
                :list="noneMotorClassOptions"
                :isColumn="false"
                @change="filterData"></v-checkbox-group>

            </div>
            <div class="half">
              <span
                class="display-flex flex-sb-center mg-t-10"
                @click="isShowSMEMore=!isShowSMEMore">
                <span>SME</span>
                <!--                <span-->
                <!--                  :class="isShowSMEMore?'el-icon-arrow-up':'el-icon-arrow-down'"-->
                <!--                ></span>-->
              </span>
              <section>
                <v-checkbox-group
                  v-model="class_id"
                  :list="sme_class_data"
                  :isColumn="false"
                  @change="filterData"></v-checkbox-group>
              </section>
            </div>
          </div>
        </div>
      </div>

      <div class="filter-right type-button">
        <div class="form-item ">
          <span>
            Stage
            <span
              class="all"
              @click="handlerSelectAll('stts')">All</span>
            <span
              class="all"
              @click="handlerNoneAll('stts')">None</span>
          </span>
          <span   class="flex-checkout">
            <v-checkbox-group
              v-model="filter.stts"
              :type="6"
              :list="claimsList"
              @change="filterData" >
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="circle"
                    :class="{
                      'yellow-dark': [0].includes(item.id),
                      'blue': [1].includes(item.id),
                      'purple': [2].includes(item.id),
                      'green': [3].includes(item.id),
                      'red': [4].includes(item.id),
                    }"></span>
                  <span>{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </span>
        </div>
      </div>
    </div>

    <div class="transparent">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-row-class-name="'tableHeader'"
        @row-click="rowClick">
        <el-table-column
          width="80px"
          align="center">
          <template #default="{ row }">
            <div class="flex mg-l-5">
              <div class="flex-column  flex-align-center mg-l-8">
                <span
                  v-if="row.merchant_platform"
                  class="table-icon__img">
                  <img :src="getOptionName('serverTypeIcon',row.merchant_platform)" >
                </span>
                <p class="icon icon-text mg-t-8">
                  <font-awesome-icon
                    icon="hand-holding-dollar"
                    class="icon-color fs-16"/>
                </p>
              </div>
              <div  class="flex-column  flex-align-center mg-l-8">
                <div>
                  <span
                    v-show="row.company_id"
                    class="icon icon-content"
                  >
                    <img
                      :src="getOptionData('companySmallIcon', row.company_id).logo? getOptionData('companySmallIcon', row.company_id).logo: row.company_logo"
                    >
                  </span>
                </div>
                <div>
                  <span
                    v-tooltip="row.class_language"
                    class="icon icon-content"
                    :class="{'mg-t-8':row.company_id>0}"
                  >
                    <font-awesome-icon
                      v-if="row.class_id&& row.product_id!==80||row.sme_versions==3"
                      :icon="getOptionName('iconOptions', row.class_id)" />
                    <font-awesome-icon
                      v-else
                      icon="cube" />
                  </span>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Policy">
          <template #default="{ row }">
            <div
              class="flex-algin"
              @click="rowClick(row)" >
              <router-link
                class="showLick text-decoration-none"
                :to="rowClickFn(row)">
                <span class="span-label">{{ row.plan }}</span>
              </router-link>
              <p
                v-if="row.pcy_no"
                class="phone-text">
                <span  v-if="row.pcy_no"><span class="weight-text">Policy No. </span> {{ row.pcy_no }}&nbsp;&nbsp;&nbsp;</span>
              </p>
              <span
                v-if="row.order_sn"
                class="phone-text">
                <template><span class="weight-text"> Ref. </span>{{ row.order_sn }}</template>
              </span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          width="105px"
          label="Policyholder">
          <template #default="{ row }">
            <div class="flex-algin">
              <span class="span-name">{{ row.isrd_nm }}</span>
              <span>
                <span class="phone-text"> {{ row.mobile_no }}</span>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="requester"
          :show-overflow-tooltip="true"
          label="Requester">
          <template #default="{ row }">
            <div class="flex-algin">
              <span class="text-span">{{row.requester }}</span>
              <p class="liter-text">{{row.phone?row.phone:''}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Accident Date">
          <template #default="{ row }">
            <div class="flex-algin">
              <span class="text-span">{{ row.accident_date }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="200"
          :show-overflow-tooltip="true"
          label="Brief/Insured">
          <template #default="{ row }">
            <div class="flex-algin">
              <!--              <span class="text-content">{{row.description }}</span>-->
              <div class="text-container">
                <p class="text-content">{{row.description }}</p>
              </div>
              <p class="liter-text color-purple">{{row.isrd_nm}}</p>
              <p class="liter-text color-purple">{{row.id_no}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="assignee"
          label="Assigned">
          <template #default="{ row }">
            <div class="flex-algin">
              <span class="text-span">{{ row.assignee }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Status & Stage"
          width="160px">
          <template #default="{ row }">
            <div class="flex-algin">
              <div>
                <i
                  class="status-height"
                  :class="{
                    'status-one':row.status==1,
                    'status-two':row.status==2,
                    'status-three':row.status==3
                  }">{{ row.status_language }}</i>
              </div>
              <p>
                <i
                  v-if="row.stts_language"
                  class="span-status-stts"
                  :class="{
                    'orange-light':row.type==3&&[101,301].includes(row.stts),
                    'yellow-dark':[0].includes(row.stts),
                    'blue':row.type==6&&[1].includes(row.stts),
                    'green': row.type==6&&[3].includes(row.stts),
                    'red': [4].includes(row.stts)&&row.type==6,
                    'purple': [2].includes(row.stts)&&row.type==6,
                  }">{{ row.stts_language }}</i>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Created Date"
          width="120px"
        >
          <template #default="{ row }">
            <div class="flex-algin time-text">
              <!--              <span>-->
              <span>{{ row.created_at.split(" ")[0] }}</span><br>
              <span> {{ row.created_at.split(" ")[1] }}</span>
              <!--              </span>-->
            </div>
          </template>

        </el-table-column>
      </el-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>


<script>
import MixinOptions from '@/mixins/options'
import MixinProductTypeFilter from '@/mixins/product-type-filter'
import {mapActions} from 'vuex'
import {getAllTicketList} from '@api/ticket'

export default {
  name: 'list',
  mixins: [MixinOptions,MixinProductTypeFilter],
  data(){
    return{
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      filter:{
        merchant_platform: '',
        search: '',
        assignee_id: 0,
        accident_date: [],
        type: 6,
        status: [1, 2],
      },
      tableData:[]
    }
  },
  computed:{
    claimsList(){
      return this.globalOptions.ticket_claim_status || []
    },
    statusOptions() {
      return this.globalOptions.new_pcy_stts
    }
  },
  mounted() {
    this.filterData()
  },
  methods: {
    ...mapActions('filter', ['setFilterData']),
    rowClick(row) {
      let params = {
        pageConfig:this.pageConfig,
        class_id:this.class_id,
        ...this.filter
      }
      this.setFilterData({claim:params})
      this.$router.push({
        path: '/tickets/detail',
        query: {
          ticket_id: row.id
        }
      })
    },
    // 新标签打开链接
    rowClickFn(row){
      return({
        path: '/tickets/detail',
        query: {
          ticket_id: row.id
        }
      })
    },
    handlerSelectAll(target) {
      let origin = ''
      switch (target) {
        case 'class_id':
          origin = 'all_class_data'
          break
        case 'stts':
          origin = 'claimsList'
          break
      }
      const data = this[origin].reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      if(target=='stts'){
        this.filter.stts =data
      }else
        this[target] = data
      this.filterData()
    },
    handlerNoneAll(target){
      if(target=='stts'){
        this.filter.stts =[]
      }else 
        this[target] = []
      this.filterData()
    },
    filterData() {
      this.pageConfig.currentPage = 1
      this.network().getAllTicketList()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getAllTicketList()
    },
    network() {
      return {
        getAllTicketList: async () => {
          const { data } = await getAllTicketList({
            ...this.filter,
            class_id:this.class_id,
            page: this.pageConfig.currentPage,
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
        },
      }
    }
  }
}
</script>

<style scoped lang="scss">
.page-container {
  position: relative;
  color: #303133;
  .mg-r-5{
    margin-right: 5px;
  }
  .flex-algin {
    /*display: flex;*/
    /*flex-direction: column;*/
    //justify-content: space-between;
    //font-weight: 500;
    &.time-text{
      font-size: 12px;
    }
    .icon-text{
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      letter-spacing: -0.15px;
      color: #24292E;
      margin-left: 15px;
    }
    .phone-text{
      font-size: 12px;
      color: #6A737D;
      .weight-text{
        font-weight: 600;
      }
    }
    &.period-text{
      display: flex;
      flex-direction: column;
      span{
        font-size: 12px;
      }
      .asap{
        font-weight: bold;
        color: black;
        margin-left: 5px;
      }
    }
    p, span {
      min-height: 20px;
    }
    .first-text{
      color: #24292E;
      font-size: 14px;
    }
    .summary{
      font-size: 12px;
      word-break: break-word;

    }
    .summary_rgtn_no{
      color: #6A737D;
      font-size: 12px;
      border: 1px solid #6A737D;
      border-radius: 4px;
      padding: 2px 4px;
    }
    .status-height{
      height: 23px;
    }
  }
  .channel{
    font-size: 12px;
    font-weight: 600;
    color: #586069;
  }
  .icon-content{
    height: 22px;
    width: 22px;
    border-radius: 5px;
    background-color: #E1E4E8;
    color: #6A737D;
    font-size: 14px;
    text-align: center;
    line-height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #e1e4e8;
    img{
      width: 22px;
    }
  }
  .table-icon{
    &.margin-top-flex{
      margin-top: 5px;
    }
    .icon{
      margin-right: 10px;
      img{
        height: 22px;
        width: 22px;
      }
    }

    .backgroud-width{
      background: #fff!important;
      border: 1px solid #e1e4e8;
    }
  }
  .box-show__none{
    box-shadow: none;
    border: 1px solid #D1D5DA;
  }
  h1 {
    // margin-bottom: 20px;
    font-size: 34px;
  }
  .filter-container {
    margin-bottom: 30px;
    background: white;
    border: 1px solid #D1D5DA;
    padding: 0px 16px;
    .filter-left, .filter-middler, .filter-right, .filter-last {
      padding: 16px 0;
    }
    .filter-left {
      padding-right: 10px;
      width: 290px;
      flex: 2;

    }
    .filter-middler {
      padding: 15px 10px;
      border-left: 1px solid #E1E4E8;
      //border-right: 1px solid #E1E4E8;
      flex: 2;
    }
    .filter-right {
      padding: 15px 10px;
      border-left: 1px solid #E1E4E8;
      flex: 1;
    }
    .filter-box-text{
      display: flex;
      margin-bottom: 12px;
      /*justify-content: space-between;*/
      margin-right: 20px;
      span{
        margin-right: 10px;
        font-family: Inter;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 17px;
      }
      span:first-child{
        color: #24292E;
        font-weight: 600;

      }
      .flex{
        span{
          color: #0366D6;
          cursor: pointer;
        }
      }
    }
    .all {
      display: inline-block;
      padding-left: 15px;
      color: #409eff;
      cursor: pointer;
      font-weight: 600;
    }
    .flex-wrap{
      flex-wrap: wrap !important;
    }
    .filter-left-container {
      display: flex;
      align-items: center;
    }
    & > span:first-child {
      font-size: 12px;
      font-weight: bold;
    }


    .input-container {
      max-width: 360px;
    }
    .button-right {
      // position: absolute;
      // right: 0;
      margin-left: 20px;
    }

    .filter-box {
      margin-right: 20px;
      .span-status {
        display: flex;
        align-items: center;
        /deep/ .el-checkbox__label {
          margin-left: 10px;
          padding: 0 10px;
          font-size: 12px;
          border: 1px solid #b08800;
          color: #b08800;
          background: white;
          border-radius: 50px;
          line-height: 20px;
          white-space: nowrap;
        }
      }
      .upload-status {
        display: flex;
        align-items: center;
        /deep/ .el-checkbox__label {
          margin-left: 10px;
          padding: 0 10px;
          font-size: 12px;
          border: 1px solid #0366D6;
          color: #0366D6;
          background: white;
          border-radius: 50px;
          line-height: 20px;
          white-space: nowrap;
        }
      }
    }
    .type-button {
      // margin-right: 20px;
      //margin-top:20px;
      ::v-deep .el-radio {
        //margin-right: 20px!important;
        width: 138px;
        .el-radio__label {
          display: inline-block;
          padding: 0px 10px;
          height: auto;
          //line-height: 30px;
          font-size: 12px;
          border-radius: 50px;
          border: 1px solid #E1E4E8;
          color: #24292E;
          background: white;
          font-weight: 500;
          letter-spacing: 0;
          line-height: 18px;
          margin-left:8px ;
        }
      }
      .border-none{
        ::v-deep .el-radio {
          .el-radio__label {
            border: none;
            font-size: 14px;
            /*border-radius: 50px;*/
            border:none;
            color: #24292E;
            background: white;
            font-weight: 600;
            letter-spacing: 0;
            line-height: 18px;
          }
        }
      }
    }
    .status-button {
      // margin-right: 20px;
      /*margin-top:20px;*/
      ::v-deep .el-checkbox-group {
        .el-checkbox {
          .el-checkbox__label {
            span {
              display: inline-block;
              padding: 0px 10px;
              height: auto;
              //line-height: 30px;
              font-size: 12px;
              border-radius: 50px;
              border: 1px solid #E1E4E8;
              color: #24292E;
              background: white!important;
              font-weight: 500;
              letter-spacing: 0;
              line-height: 18px;
            }
          }
          &:first-child {
            .el-checkbox__label {
              span {
                border: 1px solid #735C0F;
                color: #735C0F;
              }
            }
          }
          &:nth-child(2) {
            .el-checkbox__label {
              span {
                border: 1px solid #0366D6;
                color: #0366D6;
              }
            }
          }
          &:nth-child(3) {
            .el-checkbox__label {
              span {
                border: 1px solid #22863A;
                color: #22863A;
              }
            }
          }
        }
      }
    }

    .snooze-filter {
      // margin-right: 20px;
      /*margin-top:20px;*/
      ::v-deep .el-checkbox-group {
        .el-checkbox {
          margin-right: 20px;
          .el-checkbox__label {
            padding: 0;
            span {
              display: flex;
              display: inline-block;
              //padding: 0px 10px;
              height: auto;
              //line-height: 30px;
              font-size: 14px;
              /*border-radius: 50px;*/
              border:none;
              color: #24292E;
              background: white;
              font-weight: 600;
              letter-spacing: 0;
              line-height: 18px;
            }
          }
        }
      }
    }

    .el-checkbox-group {
      display: flex;
      flex-wrap: nowrap;
    }
  }
  .span-name {
    display: block;
    color: #24292E;
    height: auto!important;
    font-size: 14px;
    word-break: break-word;
  }
  .span-label {
    display: block;
    color: #24292E;
    font-weight: 600;
    word-break: break-word;
    font-size: 14px;
    text-decoration: none;
    &:hover{
      color:  #0366D6;
    }
  }
  .half {
    flex: 1;
    & > span {
      display: block;
      padding-bottom: 5px;
      font-size: 14px;
      color: #6a737d;
    }
    /deep/.el-checkbox{
      .el-checkbox__label{
        font-size: 12px;
        color: #24292E;
      }
    }
  }
  .span-status, .span-options {
    display: inline-block;
    padding: 0px 8px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #FFFFFF;
    border-radius: 100px;
    max-width: 140px;
    word-break:keep-all;
    white-space:nowrap;
    height: 18px;
    min-height: 18px !important;
    .svg-inline--fa {
      margin-right: 5px;
      font-size: 14px;
    }
    &.pending_verify{
      padding: 0 8px;
      font-size: 12px;
      background: #FFFFFF;
      border-radius: 100px;
      line-height: 20px;
      white-space: nowrap;
      border: 1px solid #dbab09;
      color: #dbab09;
    }
    &.not_verify{
      padding: 0 8px;
      font-size: 12px;
      background: #fff;
      border-radius: 100px;
      line-height: 20px;
      white-space: nowrap;
      border: 1px solid #d73a49;
      color: #d73a49;
    }
    &.verified{
      padding: 0 8px;
      font-size: 12px;
      background: #FFFFFF;
      border-radius: 100px;
      line-height: 20px;
      white-space: nowrap;
      border: 1px solid #22863a;
      color: #22863a;
    }
  }
  .span-status{
    &.green {
      background: #28a745;
      color: white;
    }
    &.orange {
      background: #E36209;
      color: white;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.blue {
      background: #0366D6;
    }
    &.red {
      background: #d73a49;
    }
    &.min-green {
      background: #dcffe4;
      color: #28a745;
    }
  }
  .span-options{
    border: 1px solid;
    &.gray {
      border-color: #586069;
      color: #586069;
    }
    &.green {
      border-color: #22863A;
      color: #22863A;
    }
    &.red {
      border-color: #D73A49;
      color: #D73A49;
    }
    &.gold {
      border-color: #735C0F;
      color: #735C0F;
    }
    &.blue {
      border-color: #0366D6;
      color: #0366D6;
    }
    &.orange {
      border-color: #C24E00;
      color: #C24E00;
    }
    &.black {
      border-color: #24292E;
      color: #24292E;
    }
    &.yellow-dark {
      border-color: #DBAB09;
      color: #DBAB09;
    }
  }
  .span-options-2{
    &.gray {
      border-color: #586069;
      color: #586069;
    }
    &.green {
      border-color: #22863A;
      color: #22863A;
    }
    &.red {
      border-color: #D73A49;
      color: #D73A49;
    }
    &.gold {
      border-color: #735C0F;
      color: #735C0F;
    }
    &.blue {
      border-color: #0366D6;
      color: #0366D6;
    }
    &.orange {
      border-color: #C24E00;
      color: #C24E00;
    }
    &.black {
      border-color: #24292E;
      color: #24292E;
    }
  }
  .icon-color{
    &.gray {
      color: #586069;
    }
    &.green {
      color: #22863A;
    }
    &.red {
      color: #D73A49;
    }
  }
  .filter-top {
    margin-bottom: 14px;
  }
  .border-bottom-radius{
    border-radius:5px;
  }
  .purple {
    background: #6F42C1;
  }
}
.transparent{
  margin-top: 15px;
}
::v-deep .el-table{
  border-radius: 4px;
  border: 1px solid #E1E4E8;
  tr{
    td{
      //display: flex;
      padding: 10px 15px 10px 0!important;
      vertical-align: top;
      margin-right: 15px;
      //height: 40px;
      .cell{
        //min-height: 40px;
        line-height: 23px;
        position: relative;
        height: inherit;
        //margin-left: 10px;
        //margin-right: 10px;
        padding: 0;
        //padding: 5px 10px;
        //position: absolute;
        //top: 10px;
      }
    }
  }
}
::v-deep .tableHeader {
  margin-top: 30px;
  background: #F6F8FA !important;
  border-bottom: 1px solid #E1E4E8;

  th {
    background-color: #F6F8FA !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: -0.15px;
    /* Text/text-gray-dark */
    padding: 10px 0!important;
    color: #24292E!important;
    .cell{
      padding-left: 0;
    }
  }
}
.table-icon__img{
  width: 22px;
  display: block;
  img{
    width: 22px;
  }
}
.filter-box-text{
  display: flex;
  margin-bottom: 12px;
  /*justify-content: space-between;*/
  margin-right: 20px;
  span{
    margin-right: 10px;
    font-family: Inter;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 17px;
  }
  span:first-child{
    color: #24292E;
    font-weight: 600;

  }
  .flex{
    span{
      color: #0366D6;
      cursor: pointer;
    }
  }
}
.status-button {
  // margin-right: 20px;
  /*margin-top:20px;*/
  ::v-deep .el-checkbox-group {
    .el-checkbox {
      .el-checkbox__label {
        span {
          display: inline-block;
          padding: 0px 10px;
          height: auto;
          //line-height: 30px;
          font-size: 12px;
          border-radius: 50px;
          border: 1px solid #E1E4E8;
          color: #24292E;
          background: white!important;
          font-weight: 500;
          letter-spacing: 0;
          line-height: 18px;
        }
      }
      &:first-child {
        .el-checkbox__label {
          span {
            border: 1px solid #735C0F;
            color: #735C0F;
          }
        }
      }
      &:nth-child(2) {
        .el-checkbox__label {
          span {
            border: 1px solid #0366D6;
            color: #0366D6;
          }
        }
      }
      &:nth-child(3) {
        .el-checkbox__label {
          span {
            border: 1px solid #22863A;
            color: #22863A;
          }
        }
      }
    }
  }
}
.width-193{
  width: 193px;
}

.flex-checkout{
  display: flex;
  margin-top: 11px;
  .el-checkbox-group {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: flex-start;
  }
  .flex{
    align-items: center;
  }
}
.circle {
  display: inline-block;
  margin-right: 5px;
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  border-radius: 100%;
  &.orange-light {
    background: #E36209;
  }
  &.yellow-dark {
    background: #DBAB09;
  }
  &.blue {
    background: #0366D6;
  }
  &.green {
    background: #28A745;
  }
  &.red {
    background: #D73A49;
  }
  &.purple {
    background: #6F42C1;
  }
}

.status-height{
  height: 18px;
  line-height: 18px;
  padding: 0px 10px;
}
.status-two{
  border: 1px solid #0366D6;
  color: #0366D6;
  display: inline-block;
  padding: 0px 8px;
  font-size: 12px;
  border-radius: 50px;
  height: 18px;
  line-height: 18px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
}
.status-one{
  border: 1px solid #735C0F;
  color: #735C0F;
  display: inline-block;
  padding: 0px 8px;
  font-size: 12px;
  border-radius: 50px;
  height: 18px;
  line-height: 18px;
  font-style: normal;
  font-weight: 600;
}
.status-three
{
  border: 1px solid #22863A;
  color: #22863A;
  display: inline-block;
  padding: 0px 8px;
  font-size: 12px;
  border-radius: 50px;
  height: 18px;
  line-height: 18px;
  font-style: normal;
  font-weight: 600;
}
.span-status-stts{
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  display: inline-block;
  color: #FFFFFF;
  padding: 0px 8px;
  height: 18px;

  border-radius: 100px;
  &.orange-light {
    background: #E36209;
  }
  &.yellow-dark {
    background: #DBAB09;
  }
  &.blue {
    background: #0366D6;
  }
  &.green {
    background: #28A745;
  }
  &.red {
    background: #D73A49;
  }
  &.purple {
    background: #6F42C1;
  }

}
.text-container{
  //width: 200px;
  //text-overflow: ellipsis;
  //word-break: break-word;
  //overflow: hidden;
  //display: -webkit-box;
  //-webkit-line-clamp: 2;
  //-webkit-box-orient: vertical;
}
.text-content{
  white-space: normal;
}
</style>
